export default {
    //日语
    DiagnosticReport:'診断レポート',
    troubleCode:'こしょうコード',
    time:'時間',
    // 语言
    lang:{
        cn:'中国語',
        de:'ドイツ語',
        en:'英語',
        es:'スペイン語',
        fr:'フランス語',
        it:'イタリア語',
        ja:'日本語',
        ko:'韓国語',
        pt:'ポルトガル語'
    },
    PositioningPrompt:'位置情報機能をオンにして現地価格を取得します',
    FaultCode:'故障コード',
    AIDiagnosis:'AI診断',
    AIWait:'AIレポートまたは自動診断待ち',
    FailedFaultCode:'故障コード情報の取得ができません',
    AIError:'AI分析失敗',
    more:'もっと',
    StoredCodes:'保存コード',
    PendingCodes:'保留コード',
    PermanentCodes:'永久コード',
    Unknown:'未知の',
    ManufacturerControl:'自動車メーカー定義',
    continue:'続ける',
    // 引导定位
    notlimits:'位置情報の権限を取得できません',
    setupSteps:'設定手順：',
    openset:'「設定」アプリを開く',
    findSet:'ご利用のアプリを見つけましょう',
    clickset:'「位置」をクリックする',
    selectLimits:'「使用期間」または「常に」を選択',
    blackRefresh:'アプリケーションに戻ってページをリフレッシュする',
    openAppSet:'「アプリケーション管理」または「アプリ」をクリックしてください',
    findUseBrowser:'使用しているブラウザを見つける',
    clickAuthority:'「権限管理」をクリックしてください',
    findejurisd:'「位置情報」の権限を見つける',
    selectjurisd:'「許可」または「使用時に許可」を選択してください',
    phoneJurisd:'携帯アプリの位置情報アクセス権限を確認する：',
    openJurisd:'「位置情報」の権限をオンにする',
    report:'報告'
}